import { apiRoutes } from "@constants/api-routes";
import { handleRequest } from "@utils/http-util";
import { RequestTypes } from "@enums/request-types";
import { AxnAdminSession } from "@idw-types/data/management-console/axnadmin";

type GetActiveAxnAdminSessionsRequestResponse = {
    sessions: Array<AxnAdminSession>;
};

export const getActiveAxnAdminSessionsRequest = async (): Promise<{ data: GetActiveAxnAdminSessionsRequestResponse, error: any }> => {
    const route = apiRoutes.managementConsole.axnadmin.sessions.active;
    const { data, error } = await handleRequest(RequestTypes.GET, route);
    return { data, error };
};